import { render, staticRenderFns } from "./debtSupplyDetailApproval.vue?vue&type=template&id=053d006c&scoped=true"
import script from "./debtSupplyDetailApproval.vue?vue&type=script&lang=js"
export * from "./debtSupplyDetailApproval.vue?vue&type=script&lang=js"
import style0 from "./debtSupplyDetailApproval.vue?vue&type=style&index=0&id=053d006c&prod&lang=scss&scoped=true"
import style1 from "./debtSupplyDetailApproval.vue?vue&type=style&index=1&id=053d006c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d006c",
  null
  
)

export default component.exports